import { inject, Injectable } from '@angular/core';
import { type Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { type AuthenticationResult } from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../../environments/environment';
import { LogService } from './log.service';

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	private msalService = inject<MsalService>(MsalService);
	private logService = inject<LogService>(LogService);

	// Silently acquires an access token for the API. Throws on failure — callers
	// must handle errors. Never opens a popup; redirect-based re-auth is handled
	// globally by MsalInterceptor.
	public generateApiToken(): Observable<AuthenticationResult> {
		const tokenRequest = {
			scopes: environment.portalApi.scopes
		};

		return this.msalService.acquireTokenSilent(tokenRequest).pipe(
			switchMap((res) => {
				if (!environment.production) {
					sessionStorage.setItem('accessToken', res.accessToken);
				}
				return [res];
			}),
			catchError((error: unknown) => {
				this.logService.consoleError(
					'Error acquiring API token: ',
					error
				);
				return throwError(() => error);
			})
		);
	}
}
